import styled from 'styled-components'

export const SomeParagraph = styled.p`
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  margin: 16px;
  color: #525961;
`
